import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult,
} from "react-beautiful-dnd";
import { StyledBodyCell, StyledTableRow } from "./Table";
import { TableBody, TableRow } from "@mui/material";
import Icon from "@mui/material/Icon";

// Fake data generator
const getItems = (count: number) =>
  Array.from({ length: count }, (_, index) => ({
    id: `item-${index}`,
    content: `item ${index}`,
  }));

// A little function to help with reordering the result
const reorder = (list: any[], startIndex: number, endIndex: number) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 10;

const getItemStyle = (isDragging: boolean, draggableStyle: any) => ({
  // Some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid * 2,
  margin: ` ${grid}px `,
  display: "flex",
  justifyContent: "space-between",

  // Change background color if dragging
  background: isDragging ? "white" : "white",
  borderRadius: 5,
  boxShadow: isDragging ? "0 0 10px #808080b3" : "0 0 5px #80808040",

  // Styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = (isDraggingOver: boolean) => ({
  borderRadius: 10,
  //   background: isDraggingOver ? "#E2E8F0" : "#E2E8F0",
});

interface Props {
  data: any;
  items: any;
  setItems: any;
}

const DragNDrop = (props: Props) => {
  const { data, items, setItems } = props;

  const onDragEnd = (result: DropResult) => {
    // Dropped outside the list
    if (!result.destination) {
      return;
    }

    const reorderedItems = reorder(
      items,
      result.source.index,
      result.destination.index
    );

    setItems(reorderedItems);
  };
  return (
    <TableBody>
      <TableRow>
        <StyledBodyCell colSpan={5}>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                >
                  {items.map((item: any, index: any) => (
                    <Draggable
                      key={item.id}
                      draggableId={item.id}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style
                          )}
                        >
                          {`${item?.assessed_skill_code} (${item?.skill.title})`}
                          <Icon>drag_indicator_rounded</Icon>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </StyledBodyCell>
      </TableRow>
    </TableBody>
  );
};

export default DragNDrop;
